import { createStore } from 'redux';
import reducers from '../reducers/combineReducers';
import middlewares from './middlewares';
import { composeWithDevTools } from 'redux-devtools-extension';
import persistUserState from './persistUserState';
import rememberAgencyLogo from './rememberAgencyLogo';

const store = createStore(
  reducers,
  composeWithDevTools(middlewares, persistUserState())
);

rememberAgencyLogo(store);

export default store;
